/**
 * MyDetails.js
 *
 * This file contains all the route under My details
 */

import View from '@/components/componentView.vue';
import { MEMBER_MENU } from '@/constants/pageTitles';
import MemberSelection from '@/views/MemberDetails/MemberSelection.vue';
import ViewUpdateDetails from '@/views/MemberDetails/ViewUpdateDetails.vue';
import PaymentDetailsLanding from '@/views/PaymentDetails/PaymentDetailsLanding.vue';
import ViewUpdatePaymentDetails from '@/views/PaymentDetails/ViewUpdatePaymentDetails.vue';
import PremiumImpactResult from '@/views/PaymentDetails/PremiumImpactResult.vue';
import UpdateMemberDetailsPremiumImpact from '@/views/MemberDetails/UpdateMemberPremiumImpact.vue';
import NoImpactResult from '@/views/MemberDetails/NoImpactResult.vue';
import GenerateMemberCards from '../views/GenerateMemberCards/GenerateMemberCards.vue';
import SuccessRequestNewCards from '../views/GenerateMemberCards/SuccessRequestNewCards.vue';

import {
  ERROR_404_PAGE_NOT_FOUND,
  MY_DETAILS_MEMBER_SELECTION,
  MY_DETAILS_VIEW_UPDATE_DETAILS,
  PAYMENT_DETAILS,
  PAYMENT_SELECTION,
  PREMIUM_IMPACT_PAYMENT_DETAILS,
  GENERATE_MEMBER_CARD_REQUEST,
  GENERATE_MEMBER_CARD_REQUEST_SUCCESS,
  NO_IMPACT_UPDATE_DETAILS,
  PREMIUM_IMPACT_UPDATE_DETAILS,
} from './routeNames';
import { getNavigationState, peekNavigationState } from './navigationState';

export default [
  {
    path: 'member-selection',
    component: View,
    meta: {
      title: MEMBER_MENU.MEMBER_DETAILS.MEMBER_SELECTION,
    },
    children: [
      {
        path: '',
        name: MY_DETAILS_MEMBER_SELECTION,
        component: MemberSelection,
        meta: {
          title: MEMBER_MENU.MEMBER_DETAILS.MEMBER_SELECTION,
        },
      },
      {
        path: ':personCode%20:name',
        name: MY_DETAILS_VIEW_UPDATE_DETAILS,
        component: ViewUpdateDetails,
        meta: {
          title: MEMBER_MENU.MEMBER_DETAILS.MEMBER_SELECTION,
        },
        children: [
          {
            path: NO_IMPACT_UPDATE_DETAILS,
            name: NO_IMPACT_UPDATE_DETAILS,
            component: NoImpactResult,
            meta: {
              title: MEMBER_MENU.MEMBER_DETAILS.NO_IMPACT,
            },
            props: () => getNavigationState(), // this is required so that `flowName` prop is passed to NoImpactResult.vue for prefill
            beforeEnter: () => {
              const vuexState = JSON.parse(window.sessionStorage.getItem('vuex')).MemberDetails;
              const accessAllowed = vuexState.submitUpdateSuccessful || vuexState.submitPolicyInProcess; 
              if (!accessAllowed) {
                return { name: ERROR_404_PAGE_NOT_FOUND };
              }
            },
          },
          {
            path: PREMIUM_IMPACT_UPDATE_DETAILS,
            name: PREMIUM_IMPACT_UPDATE_DETAILS,
            component: UpdateMemberDetailsPremiumImpact,
            meta: {
              title: MEMBER_MENU.MEMBER_DETAILS.PREMIUM_IMPACT,
            },
            beforeEnter: () => {
              const accessAllowed = JSON.parse(window.sessionStorage.getItem('vuex')).MemberDetails.submitUpdateSuccessful;
              if (!accessAllowed) {
                return { name: ERROR_404_PAGE_NOT_FOUND };
              }
            },
          },
        ],
      },
    ],
  },
  {
    path: PAYMENT_SELECTION,
    component: View,
    meta: {
      title: MEMBER_MENU.PAYMENT_DETAILS.LANDING,
    },
    children: [
      {
        path: '',
        name: PAYMENT_SELECTION,
        component: PaymentDetailsLanding,
        meta: {
          title: MEMBER_MENU.PAYMENT_DETAILS.LANDING,
        },
      },
      {
        // path: ':personCode%20:name',
        path: 'details',
        name: PAYMENT_DETAILS,
        component: ViewUpdatePaymentDetails,
        meta: {
          title: MEMBER_MENU.PAYMENT_DETAILS.VIEW_UPDATE_DETAILS,
        },
        props: () => getNavigationState(),
        beforeEnter: (to) => {
          if (!peekNavigationState().selectedMember) {
            // redirect to payment selection page if directly visiting via url so that `selectedMember` param(required) is populated for ViewUpdatePaymentDetails.vue (also makes sure DoA rules are respected).
            return { name: PAYMENT_SELECTION, params: { policyNumber: to.params?.policyNumber } };
          }
        },
        // children: [],
      },
      {
        path: 'result',
        name: PREMIUM_IMPACT_PAYMENT_DETAILS,
        component: PremiumImpactResult,
        meta: {
          title: MEMBER_MENU.PAYMENT_DETAILS.RESULT,
        },
        props: () => getNavigationState(),
        beforeEnter: (to) => {
          const vuexState = JSON.parse(window.sessionStorage.getItem('vuex')).PaymentDetails;
          if (!peekNavigationState().selectedMember && !vuexState.submitPolicyInProcess) {
            // redirect to payment selection page if directly visiting via url so that `selectedMember` param(required) is populated for PremiumImpactResult.vue (also makes sure DoA rules are respected).
            return { name: PAYMENT_SELECTION, params: { policyNumber: to.params?.policyNumber } };
          }
        },
      },
    ],
  },
  {
    path: 'generate-member-card',
    name: GENERATE_MEMBER_CARD_REQUEST,
    component: GenerateMemberCards,
    meta: {
      title: MEMBER_MENU.MEMBER_CARD.REQUEST,
    },
  },
  {
    path: 'request-success',
    name: GENERATE_MEMBER_CARD_REQUEST_SUCCESS,
    component: SuccessRequestNewCards,
    props: () => getNavigationState(),
    meta: {
      title: MEMBER_MENU.MEMBER_CARD.SUCCESS,
    },
  },
];
